export default string => string.split("_").join(" ")